import styled from 'styled-components';
import { Card } from '@pearsontechnology/aero-components';
import homeLightBg from 'images/home-light.png';
import homeDarkBg from 'images/home-dark.png';
import bannerBg from './images/topography-pattern.svg';

export const PageViewportWithBg = styled.div`
  background-color: ${(props) => props.theme['color.background']};
  flex: 1 1 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background-image: url(${(props) => props.theme.themeId === 'dark' ? homeDarkBg : homeLightBg});
  background-repeat: no-repeat;
  background-size: 575px;
  background-position: right 0px top 0px;
  padding-bottom: 120px;

  @media (max-width: ${(props) => props.theme['media.tablet']}px) {
    background-size: 480px;
    background-position: right -50px top 0;
  }

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    background-size: 400px;
    background-position: right -70px top 0;
  }
`;

export const HomepageSubheading = styled.div`
  height: 19px;
  color: ${(props) => props.theme['color.text.body']};
  font-size: 16px;
  line-height: 19px;
`;

export const HomepageHeader = styled.div`
  padding: 40px 0;
`;

export const WelcomeMessage = styled.p`
  color: ${(props) => props.theme['color.text.title']};
  font-size: 32px;
  line-height: 38px;
  padding: 20px 0px;
  margin: 0;
`;

export const MessageBanner = styled(Card)`
  padding: 20px;
  background: ${(props) => props.theme['color.blueDark']};
  color: white;
  align-items: flex-start;
  background-image: url(${bannerBg});
  background-repeat: no-repeat;
  background-size: auto 100%;
  transition-property: opacity, transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 0.6s;
  transition-delay: 0.2s;
  opacity: 0;
  transform: translate3d(0, 10%, 0);
  position: relative;
  z-index: 1;

  ${(props) => props.status === 'entered' && `
    opacity: 1;
    transform: translate3d(0, 0, 0);
  `}

  @media (min-width: 1200px) {
    padding: 30px;
  }
`;

export const MessageBannerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;

  @media (max-width:${(props) => props.theme['media.mobile']}px) {
    & > button {
      display: none;
    }
  }
`;

export const MessageBannerTitle = styled.h2`
  font-size: 30px;
  font-weight: 600;
  line-height: 1.1;
  margin: 0;
  flex: 0 1 auto;
`;

export const MessageBannerParagraph = styled.p`
  font-size: 18px;
  line-height: 1.4;
  margin: 0;
  max-width: 960px;

  & + & {
    margin-top: 16px;
  }
`;

export const HelpMenuPrompt = styled.div`
  position: absolute;
  bottom: 30px;
  right: 76px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  svg {
    fill: ${(props) => props.theme['color.text.light']};
    margin-top: 10px;
    position: relative;
    left: 20px;
  }
`;

export const HelpMenuPromptText = styled.div`
  color: ${(props) => props.theme['color.text.body']};
  font-size: 14px;
  text-align: center;
  line-height: 1.2;
  max-width: 120px;
`;

